module.exports = __webpack_public_path__ + "static/media/editPen.c97ba8ef.svg";